import { render, staticRenderFns } from "./VariableRadio.vue?vue&type=template&id=dfed31c0&"
import script from "./VariableRadio.vue?vue&type=script&lang=ts&"
export * from "./VariableRadio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports